/**
 * Item 2 — bulk-import shipping-rule flow (order views).
 *
 * Normalizes the shipping-rule attribution fields off a raw merchant order
 * payload item.
 *
 * The merchant order payload now exposes `applied_rule_name` /
 * `applied_rule_uid` — the rule that ACTUALLY assigned the order's carrier.
 * Both are `null` when the merchant overrode the carrier (no rule attribution).
 *
 * The legacy fields (`winning_rule_uid`, `winning_rule_name_at_assignment`,
 * `assigned_via_rule_uid`, `carrier_override_reason`) were removed from the
 * merchant payload; this helper intentionally does NOT read them so a stale
 * or fabricated rule name can never leak into the UI.
 */
export interface AppliedRule {
  applied_rule_name: string | null;
  applied_rule_uid: string | null;
}

export function extractAppliedRule(item: Record<string, unknown> | null | undefined): AppliedRule {
  const name = item?.applied_rule_name;
  const uid = item?.applied_rule_uid;
  return {
    applied_rule_name: typeof name === 'string' && name.trim() ? name : null,
    applied_rule_uid: typeof uid === 'string' && uid.trim() ? uid : null,
  };
}
